// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__njBcX","tyre":"style_tyre__0p8My"};